import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

export const useSubscriptionGuard = () => {
  const privileges = useSelector((state) => state.auth?.privileges);
  const isSubscriptionExpired = privileges?.isSubscriptionExpired || false;

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSubscriptionExpired) return;

    const { pathname } = location;

    // List of protected routes
    const protectedPaths = [
      "/dental-identification/projects/new-project",
      "/dental-identification/projects/details/case-registration/am",
      "/dental-identification/projects/details/case-registration/pm",
      "/dental-identification/projects/details/case/add-dental-record",
      "/age-assessment/cases/new-case",
      "/age-assessment/cases/new-case/dental-examination",
      "/age-assessment/cases/age-group",
      "/age-assessment/cases/age-group/sub-adult/primary",
      "/age-assessment/cases/age-group/adults/radiographic-tooth-analysis",
      "/age-assessment/cases/age-group/sub-adult/permanent",
      "/age-assessment/cases/age-group/adults/adults/intact-tooth-analysis",
      "/age-assessment/cases/age-group/sub-adult/wisdome",
      "/age-assessment/cases/age-group/adults/sectioned-tooth-analysis",
      "/length-measurement",
      "/area-measurement",
      "/ai-measurement",
      // "/dental-analysis/projects",
      // "/dental-analysis/projects/",
    ];

    const isProtected = protectedPaths.some((path) =>
      pathname.startsWith(path)
    );

    if (isProtected) {
      navigate("/subscription-expired", {
        replace: true,
      });
    }
  }, [location, isSubscriptionExpired, navigate]);
};
